import { OIDC_LOGIN_URL } from './config';
export function getOidcLoginUrl() {
  if (typeof OIDC_LOGIN_URL !== 'string') {
    return null;
  }
  const trimmed = OIDC_LOGIN_URL.trim();
  return trimmed === '' ? null : trimmed;
}
export function redirectToOidcLogin() {
  const url = getOidcLoginUrl();
  if (url) {
    window.location.assign(url);
  }
}
export function isOidcLoginEnabled() {
  return getOidcLoginUrl() !== null;
}
flarum.reg.add('dia-theme', 'forum/features/oidc-login/redirect', { getOidcLoginUrl: getOidcLoginUrl,redirectToOidcLogin: redirectToOidcLogin,isOidcLoginEnabled: isOidcLoginEnabled, });